import { useSnackbar } from "notistack";
import React, { useContext } from "react";
import { useCallback } from "react";
import VerificationInput from "react-verification-input";
import { useHistory } from "react-router-dom";
import { CompanyLogo } from "../../../Components/Atoms";
import { Button } from "../../../Components/Atoms";
import { Countdown } from "../../../Components/Molecules";
import { VerificationContainer, ButtonsContainer } from "./styles";
import { useAuth } from "../../../Contexts/AuthContext";

// import MetaDecorator from "../../components/MetaDecorator";

const VerificationCodeLogin: React.FC = () => {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [code, setcode] = React.useState("");
  const [verificationDisable, setVerificationDisable] = React.useState(false);

  const { twoFactor, isLoading, resendCode, user } = useAuth();

  const handleValidatingCode = useCallback(() => {
    if (code.length !== 6) {
      enqueueSnackbar("Código inválido ou incompleto", {
        variant: "error",
      });
      return;
    }
    twoFactor({ code });
  }, [code, twoFactor, enqueueSnackbar]);

  return (
    <VerificationContainer>
      <CompanyLogo width={170} height={50} />
      <p>Verificação em duas etapas</p>
      <p>
        Para sua segurança, insira o código de verificação enviada para o número
        de telefone {user.phone_number}
      </p>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleValidatingCode();
        }}
      >
        <div className="custom-styles">
          <VerificationInput
            length={6}
            onChange={setcode}
            placeholder=""
            inputProps={{
              onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  (e.currentTarget.form as HTMLFormElement | null)?.requestSubmit();
                }
              },
            } as any}
          />
        </div>
        <Countdown
          expireTime={45}
          resendCode={(type: string) => {
            resendCode();
          }}
          isExpired={(isExpired: boolean) => {
            setVerificationDisable(isExpired);
          }}
        />
        <ButtonsContainer>
          <Button
            action={"return"}
            type="button"
            onClick={() => {
              history.push("/auth");
            }}
          >
            Voltar
          </Button>
          <Button type="submit" loading={isLoading} disabled={verificationDisable}>
            Verificar
          </Button>
        </ButtonsContainer>
      </form>
    </VerificationContainer>
  );
};

export default VerificationCodeLogin;
